exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gravame-register-dashboard-page .app-main{padding:0 !important}.gravame-register-dashboard-page .content-documentation iframe.template-documentation{width:100%;height:100%;height:100vh}", ""]);

// exports
